import { jsx, jsxs } from 'react/jsx-runtime';
import { cn } from '../../lib/utils.js';
import { AnimatePresence, motion } from 'motion/react';
import { useState, useCallback, useEffect } from 'react';

const FlipWords = ({ words, duration = 3000, className, }) => {
    const [currentWord, setCurrentWord] = useState(words[0]);
    const [isAnimating, setIsAnimating] = useState(false);
    // thanks for the fix Julian - https://github.com/Julian-AT
    const startAnimation = useCallback(() => {
        const word = words[words.indexOf(currentWord) + 1] || words[0];
        setCurrentWord(word);
        setIsAnimating(true);
    }, [currentWord, words]);
    useEffect(() => {
        if (!isAnimating)
            setTimeout(() => {
                startAnimation();
            }, duration);
    }, [isAnimating, duration, startAnimation]);
    return (jsx(AnimatePresence, Object.assign({ onExitComplete: () => {
            setIsAnimating(false);
        } }, { children: jsx(motion.div, Object.assign({ initial: {
                opacity: 0,
                y: 10,
            }, animate: {
                opacity: 1,
                y: 0,
            }, transition: {
                type: "spring",
                stiffness: 100,
                damping: 10,
            }, exit: {
                opacity: 0,
                y: -40,
                x: 40,
                filter: "blur(8px)",
                scale: 2,
                position: "absolute",
            }, className: cn("tw:z-10 tw:inline tw:relative tw:text-left", className) }, { children: currentWord.split(" ").map((word, wordIndex) => (jsxs(motion.span, Object.assign({ initial: { opacity: 0, y: 10, filter: "blur(8px)" }, animate: { opacity: 1, y: 0, filter: "blur(0px)" }, transition: {
                    delay: wordIndex * 0.3,
                    duration: 0.3,
                }, className: "tw:inline-block tw:whitespace-nowrap" }, { children: [word.split("").map((letter, letterIndex) => (jsx(motion.span, Object.assign({ initial: { opacity: 0, y: 10, filter: "blur(8px)" }, animate: { opacity: 1, y: 0, filter: "blur(0px)" }, transition: {
                            delay: wordIndex * 0.3 + letterIndex * 0.05,
                            duration: 0.2,
                        }, className: "tw:inline-block" }, { children: letter }), word + letterIndex))), jsx("span", Object.assign({ className: "tw:inline-block" }, { children: "\u00A0" }))] }), word + wordIndex))) }), currentWord) })));
};

export { FlipWords };
//# sourceMappingURL=flip-words.js.map
